// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.peoplesection-inline-1 {
  width: 100%;
  padding: 10px 14px;
  border-radius: 10px;
  border: 1px solid #e2e8f0;
  font-size: 12px;
  margin-bottom: 14px;
  box-sizing: border-box;
}

.peoplesection-inline-2 {
  text-align: center;
  padding: 30px;
  color: #94a3b8;
}

.peoplesection-inline-3 {
  text-align: center;
  padding: 30px;
  color: #94a3b8;
}

.peoplesection-inline-4 {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 12px;
}

.peoplesection-inline-5 {
  padding: 14px;
  display: flex;
  gap: 12px;
  align-items: center;
}

.peoplesection-inline-6 {
  font-weight: 600;
  font-size: 13px;
}

.peoplesection-inline-7 {
  font-size: 11px;
  color: #64748b;
}

.peoplesection-inline-8 {
  font-size: 10px;
  color: #94a3b8;
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/Intern/PeopleSection.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB","sourcesContent":[".peoplesection-inline-1 {\n  width: 100%;\n  padding: 10px 14px;\n  border-radius: 10px;\n  border: 1px solid #e2e8f0;\n  font-size: 12px;\n  margin-bottom: 14px;\n  box-sizing: border-box;\n}\n\n.peoplesection-inline-2 {\n  text-align: center;\n  padding: 30px;\n  color: #94a3b8;\n}\n\n.peoplesection-inline-3 {\n  text-align: center;\n  padding: 30px;\n  color: #94a3b8;\n}\n\n.peoplesection-inline-4 {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));\n  gap: 12px;\n}\n\n.peoplesection-inline-5 {\n  padding: 14px;\n  display: flex;\n  gap: 12px;\n  align-items: center;\n}\n\n.peoplesection-inline-6 {\n  font-weight: 600;\n  font-size: 13px;\n}\n\n.peoplesection-inline-7 {\n  font-size: 11px;\n  color: #64748b;\n}\n\n.peoplesection-inline-8 {\n  font-size: 10px;\n  color: #94a3b8;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
